export default __webpack_public_path__ + "static/media/pumaCover.06e66e06.jpg";